import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Sponsor } from '../sponsor';
import { SponsorService } from '../sponsor.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-sponsor-details',
    templateUrl: './sponsor-details.component.html',
    styleUrls: ['./sponsor-details.component.scss'],
    standalone: false
})
export class SponsorDetailsComponent extends BaseComponent implements OnInit {

  public id: string;
  public sponsor: Sponsor = new Sponsor();

  constructor(public sessionService: SessionService,
    private route: ActivatedRoute,
    private sponsorService: SponsorService,
    stringHelpers: StringHelpers) { 
    super(sessionService, stringHelpers);
  }
  
  ngOnInit(): void {
    if(this.isGlobalOutingSet()){
      this.selectedIteration = this.getGlobalOutingIteration();
      this.id = this.route.snapshot.paramMap.get('id');
      this.getSponsorById();
    }
  }

  getSponsorById(){
    this.isLoading = true;
    this.sponsorService.getById(this.id).subscribe(result => {
      this.sponsor = result;
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      console.error(err);
    });
  }

}
